<template>
  <div class="justify-center" style="width: 100%">
    <div
      style="
        line-height: 1.8;
        background-color: #2b3137;
        width: 90%;
        margin-top: 50px;
        border-radius: 7px;
      "
    >

      <el-container class="app-item-contain">
        <el-header class="align-center1" style="margin-top: 20px">
          <h1
            @click="goBack"
            style="font-size: 30px; font-weight: bolder; color: white;float: left;"
          >
                <div style="display: inline-block;">Back</div>
          </h1>
        </el-header>
        <!-- <div class="justify-center" style="color: white">
          <div style="margin-left: 30px; font-size: 12px; line-height: 30px">
            
          </div>
        </div> -->
        <el-main style="display: flex; justify-content: center">
          <el-card style="width: 100%">
            <h2>
              현재 회원님의TV/디바이스는 이 계정의 넷플릭스 이용가구에 포함되어
              있지 않습니다
            </h2>
            <h4>
              만약 TV나 디바이스에서 [현재 회원님의TV/디바이스는 이 계정의
              넷플릭스 이용가구에 포함되어 있지 않습니다]라고 표시될때,
            </h4>
                <img
                src="https://alongshare.oss-eu-west-1.aliyuncs.com/frontend/nfcode1.png"
                height="100%"
                width="100%"
              />
            <h4>다음 단계를 따라 접속 권한을 다시 얻으십시오:</h4>
            <h4>Step 1:</h4>
            <h4>화면에서 '현재 여행 중' 또는 '임시로 시청'을 선택하세요.</h4>
                <img src="https://alongshare.oss-eu-west-1.aliyuncs.com/frontend/nfcode2.png" height="100%"
                width="100%">
            <h4>Step 2:</h4>
            <h4>기기에서 '이메일 보내기' 버튼을 클릭하면, Alongshare 코드를 확인할 수 있습니다.
            </h4>
            <img src="https://alongshare.oss-eu-west-1.aliyuncs.com/frontend/nfcode3.png" height="100%"
            width="100%">
            <h4>Step 3:</h4>
            <h4>'구독' 페이지 > Netflix로 이동한 후 '링크를 받으려면 클릭'을 클릭하세요. 이 과정은 1~3분 정도 소요됩니다.
            </h4>
            <img src="https://alongshare.oss-eu-west-1.aliyuncs.com/frontend/nfcode4.png" height="100%"
            width="100%">
            <h4>Step 4:</h4>
            <h4>'get Netflix code'를 클릭하세요.
            </h4>
            <img src="https://alongshare.oss-eu-west-1.aliyuncs.com/frontend/nfcode5.png" height="100%"
            width="100%">
            <h4>Step 5:</h4>
            <h4>받은 인증 코드를 PC나 기기에 입력하여 넷플릭스 시청을 계속 즐기세요.
            </h4>
            <img src="https://alongshare.oss-eu-west-1.aliyuncs.com/frontend/nfcode6.png" height="100%"
            width="100%">
            <h2>절차를 따라도 인증 링크를 얻지 못하는 경우?</h2>
            <h4>다음 두 가지 방법을 시도해보세요:</h4>
            <h4>네트워크 변경 (추천✅)</h4>
            <h4>
                계정에서 로그아웃하세요.
                로그인에 사용하는 TV/장치의 라우터/모뎀을 재시작하거나 네트워크를 변경하세요 (새로운 IP 주소를 얻게 됩니다) (라우터/네트워크를 어떻게 재시작하나요?)
                다시 로그인하세요</h4>
            <h4>또는 장치를 변경하세요.</h4>
            <h4>각 장치는 24시간 내에 최대 4회 링크를 얻을 수 있습니다. </h4>
            <h4>😊그런 다음 다시 인증 링크를 얻어보세요.</h4>
            <h4>Netflix에서: '여행 중' 또는 '일시적으로 시청'을 클릭 > '이메일 보내기'

                이 방법들이 여전히 작동하지 않는 경우, 임시로 웹 브라우저를 사용하여 로그인하고 시청해보세요, 그리고 24시간 후에 다시 인증 링크를 얻어보세요.
                </h4>
            <h2>
                장치가 더 이상 코드를 요청할 수 없다고 표시합니까?
            </h2>
            <h4>24시간 후에 장치를 변경한 후 코드를 다시 요청하세요. 각 장치는 24시간 내에 링크를 최대 네 번까지 얻을 수 있습니다. 여전히 얻을 수 없는 경우, 임시로 웹 브라우저를 사용하여 로그인하고 시청하세요.</h4>
          </el-card>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
// import { getHelpdetailByid } from "@/request/requests";
// import { MessageError } from "@/util/util";
export default {
  name: "nfcode",
  data() {
    return {
      form: {},
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // async getHelpdetailByidInfo() {
    //   let res = await getHelpdetailByid(this.$route.query.id);
    //   if (res.status == "200") {
    //     this.form = res.data.list[0];
    //   } else {
    //     MessageError(res.msg);
    //   }
    // },
  },
  watch: {
    $route() {
      //   this.getHelpdetailByidInfo();
    },
  },
  created() {
    // this.getHelpdetailByidInfo();
  },
};
</script>

<style scoped>
.align-center1 {
  text-align: center;
}
@media only screen and (max-width: 768px) {
  .app-item-contain {
    padding: 30px 0px 0px 0px;
  }

  .app-contain {
    padding: 30px 0px 0px 0px;
  }
}
</style>
